<template>
  <v-container>
    <v-textarea
      visible
      outlined
      :label="$t('summary_message', { vesselType: $t(textVesselType).toLowerCase()})"
      v-model="summary"
    ></v-textarea>

    <v-row align="center">
      <v-col
        cols=12
        sm=4
      >
        <v-select
          :items="nationalities"
          :label="$t('group_nationality')"
          :item-text="item => $t(item.text)"
          item-value="value"
          v-model="groupNationality"
          clearable
        ></v-select>
      </v-col>

      <v-col
        cols=12
        sm=4
      >
        <v-text-field
          :label="$t('drug_type_message')"
          v-model="drugs"
        />
      </v-col>

      <v-col
        cols=12
        sm=4
      >
        <v-text-field
          :label="$t('modus_operandi')"
          v-model="modusOperandi"
        />
      </v-col>

      <v-col
        cols=12
        sm=6
      >
        <v-text-field
          :label="$t('investigation_links_message')"
          v-model="groupLinks"
        />
      </v-col>

      <v-col
        cols=12
        sm=6
      >
        <v-text-field
          :label="$t('vessel_possible_destinations')"
          v-model="possibleDestinations"
        />
      </v-col>

      <v-col
        cols=12
      >
        <v-select
          v-model="infoType"
          :items="infoOptions"
          :item-text="item => $t(item.text)"
          item-value="value"
          :label="$t('information_type')"
          :rules="infoRequired() ? [
            v => !!v && v.length > 0 || $t('information_type_required')
          ] : []"
          multiple
          outlined
        >
        </v-select>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { maocData } from '../../services/MaocData'

export default {
  name: 'OperationSummary',
  props: [
    'vesselType',
    'request'
  ],
  data: vm => ({
    summary: '',
    groupNationality: '',
    drugs: '',
    modusOperandi: '',
    groupLinks: '',
    possibleDestinations: '',
    infoType: '',
    nationalities: maocData.dynamicLocalizedSelect('countries'),
    infoOptions: maocData.asLocalizedSelect('informationOptions')
  }),
  computed: {
    textVesselType () {
      if (this.vesselType === 'aeroplane') {
        return 'aeroplane'
      } else {
        return 'vessel'
      }
    }
  },
  methods: {
    getData: function () {
      const exportData = {
        summary: this.summary,
        groupNationality: this.groupNationality,
        drugs: this.drugs,
        modusOperandi: this.modusOperandi,
        groupLinks: this.groupLinks,
        possibleDestinations: this.possibleDestinations,
        infoType: this.infoType
      }

      if (exportData.groupNationality) {
        exportData.groupNationality_en = this.$t('countries.' + exportData.groupNationality, 'en')
      }

      if (exportData.infoType) {
        exportData.infoType_en = []
        const vm = this
        exportData.infoType.forEach(function (item) {
          exportData.infoType_en.push(vm.$t(item, 'en'))
        })
      }

      return exportData
    },
    setData: function (data) {
      this.summary = data.summary
      this.groupNationality = data.groupNationality
      this.drugs = data.drugs
      this.modusOperandi = data.modusOperandi
      this.groupLinks = data.groupLinks
      this.possibleDestinations = data.possibleDestinations
      this.infoType = data.infoType
    },
    infoRequired: function () {
      return (this.request === 'registration') ||
        (this.request === 'upgrade') ||
        (this.request === 'reactivation')
    }
  }
}
</script>
